import { Record } from 'immutable';

const CustomLabelRequestRecord = Record({
  chainCode: null,
  brandCode: null,
  propertyId: null,
  customerNum: null,
  iata: null
});

export class CustomLabelRequest extends CustomLabelRequestRecord {
  chainCode: string;
  brandCode: string;
  propertyId: string;
  customerNum: string;
  iata: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/custom-label-request.ts